import { Mutations } from "vuex";
import { ActionCableState, ActionCableMutations } from "./types";

export const mutations: Mutations<ActionCableState, ActionCableMutations> = {
  updateActionCable(state, payload) {
    Object.assign(state, payload);
  },
};
